import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { NewResidentForm, formatPhoneNumber } from './types';

type RoleType = NewResidentForm['role'];

interface AddResidentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  form: NewResidentForm;
  onFormChange: (form: NewResidentForm) => void;
  onSave: () => void;
  formatPersonalNumberInput: (value: string) => string;
}

export function AddResidentDialog({
  open,
  onOpenChange,
  form,
  onFormChange,
  onSave,
  formatPersonalNumberInput
}: AddResidentDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Lägg till boende</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2">
              <Label>Förnamn *</Label>
              <Input
                value={form.first_name}
                onChange={(e) => onFormChange({ ...form, first_name: e.target.value })}
                placeholder="Anna"
                data-testid="resident-first-name-input"
              />
            </div>
            <div className="space-y-2">
              <Label>Efternamn *</Label>
              <Input
                value={form.last_name}
                onChange={(e) => onFormChange({ ...form, last_name: e.target.value })}
                placeholder="Andersson"
                data-testid="resident-last-name-input"
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label>E-post *</Label>
            <Input
              type="email"
              value={form.email}
              onChange={(e) => onFormChange({ ...form, email: e.target.value })}
              placeholder="anna@example.com"
              data-testid="resident-email-input"
            />
          </div>
          <div className="space-y-2">
            <Label>Telefon</Label>
            <Input
              value={form.phone}
              onChange={(e) => onFormChange({ ...form, phone: formatPhoneNumber(e.target.value) })}
              placeholder="07-123 45 67"
              data-testid="resident-phone-input"
            />
            <p className="text-xs text-slate-400">Format: xx-xxx xx xx</p>
          </div>
          <div className="space-y-2">
            <Label>Personnummer</Label>
            <Input
              value={form.personal_number}
              onChange={(e) => onFormChange({ ...form, personal_number: formatPersonalNumberInput(e.target.value) })}
              placeholder="YYYYMMDD-XXXX"
              className="font-mono"
              maxLength={13}
              data-testid="resident-pnr-input"
            />
            <p className="text-xs text-slate-400">Format: YYYYMMDD-XXXX (de sista 4 krypteras)</p>
          </div>
          <div className="space-y-2">
            <Label>Roll</Label>
            <Select
              value={form.role}
              onValueChange={(value) => onFormChange({ ...form, role: value as RoleType })}
            >
              <SelectTrigger data-testid="resident-role-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="resident">Boende</SelectItem>
                <SelectItem value="board_member">Styrelsemedlem</SelectItem>
                <SelectItem value="suppliant">Suppleant</SelectItem>
                <SelectItem value="auditor">Revisor</SelectItem>
                <SelectItem value="admin">Admin</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <Button onClick={onSave} className="w-full" data-testid="save-resident-button">
            Lägg till
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
